export default __webpack_public_path__ + "static/media/Untitled-2.4f332d58.png";